var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 .75c7.525 0 14.337 3.05 19.269 7.981A27.165 27.165 0 0 1 55.25 28c0 7.525-3.05 14.337-7.981 19.269A27.165 27.165 0 0 1 28 55.25a27.165 27.165 0 0 1-19.269-7.981A27.165 27.165 0 0 1 .75 28c0-7.525 3.05-14.337 7.981-19.269A27.165 27.165 0 0 1 28 .75z",
    stroke: "#272726",
    strokeWidth: 1.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#272726",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.339 17.593C34.978 15.276 31.839 14 28.5 14c-3.339 0-6.478 1.276-8.839 3.593C17.301 19.909 16 22.989 16 26.266c0 6.627 6.386 12.14 9.817 15.101.477.412.889.767 1.217 1.068.411.377.939.565 1.466.565.528 0 1.055-.188 1.466-.565.328-.3.74-.656 1.217-1.068C34.613 38.406 41 32.893 41 26.266c0-3.277-1.3-6.357-3.661-8.673zm-7.3 22.499c-.487.42-.908.784-1.255 1.102a.424.424 0 0 1-.568 0c-.347-.318-.768-.682-1.255-1.102-3.226-2.784-9.23-7.967-9.23-13.826 0-5.827 4.831-10.567 10.769-10.567s10.769 4.74 10.769 10.567c0 5.859-6.004 11.042-9.23 13.826z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 20.397c-3.037 0-5.509 2.425-5.509 5.405 0 2.98 2.472 5.405 5.509 5.405 3.037 0 5.509-2.424 5.509-5.405 0-2.98-2.472-5.405-5.509-5.405zm0 9.112c-2.083 0-3.777-1.663-3.777-3.707 0-2.044 1.694-3.706 3.777-3.706s3.777 1.662 3.777 3.706-1.694 3.707-3.777 3.707z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBtn);
export default __webpack_public_path__ + "static/media/locationBtn.137e2f1da53cc6c7224e1c4f65e2dfe8.svg";
export { ForwardRef as ReactComponent };